export class BookingSlotVelocityLimitOverrideDTO {

    constructor(
        public id: string,
        public startDateTime: string,
        public bookingLimit: number | null,
        public coverLimit: number | null,
        public reasonId: string | null,
        public eventId: string | null
    ) { }
}
